import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { DropdownModule } from '@app/primeng-overrides/dropdown';
import { InputTextModule } from 'primeng/inputtext';

import { UtilisateurService } from '@app/utilisateur/utilisateur.service';

import { ControlValueAccessorBase } from '@app/_helpers/control-value-accessor-base';
import { TranslateService } from '@codeandweb/ngx-translate';

@Component({
	selector: 'civilite-selector',
	 providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CiviliteSelectorComponent),
			multi: true
		}
	],
	template: `
		<input
			type="text"
			pInputText
			[name]="name"
			[ngModel]="value"
			readonly
			*ngIf="readonly"
		>
		<p-dropdown
			[name]="name"
			#civilite
			[(ngModel)]="value"
			[editable]="true"
			[disabled]="disabled"
			[options]="options"
			[required]="required"
			[placeholder]="placeholder"
			*ngIf="!readonly"
		></p-dropdown>
	`
})
export class CiviliteSelectorComponent extends ControlValueAccessorBase<string> implements OnInit  {

	@Input() name: string;
	@Input('value') innerValue: string;
	@Input() readonly: boolean;
	@Input() disabled: boolean;
	@Input() required: boolean;
	@Input() placeholder: string

	options: string[] = [];

	constructor(private utilisateurService: UtilisateurService, private translateService: TranslateService) {
		super();
	}

	ngOnInit() {
		this.options = this.utilisateurService.getCivilites('long');
		if (!this.placeholder) {
			this.placeholder = this.translateService.instant('common.salutation_selector_placeholder');
		}
	}

}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		DropdownModule,
		InputTextModule,
	],
	exports: [CiviliteSelectorComponent],
	declarations: [CiviliteSelectorComponent]
})
export class CiviliteSelectorModule { }
